"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _Button = _interopRequireDefault(require("../../../../../ui/Button"));
var _AddHotelToCollectionsModal = require("../../../../../collections/components/AddHotelToCollectionsModal");
var _actions = require("../../../../store/actions");
var _selectors = require("./store/selectors");
var _heart = _interopRequireDefault(require("./heart.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AddToCollectinButton = function AddToCollectinButton(_ref) {
  var countryID = _ref.countryID,
    hotelID = _ref.hotelID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var isAdded = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getIsAddedHotel2Collection)(state, {
      hotelID: hotelID
    });
  });
  var handleClick = function handleClick() {
    return dispatch((0, _AddHotelToCollectionsModal.showAddHotelToCollectionsModal)(function (isAddedSuccessfully) {
      if (isAddedSuccessfully) {
        dispatch((0, _actions.addHotel2Collections)(hotelID));
      }
    }, {
      countryID: countryID,
      hotelID: hotelID
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('OPEN_ADD_HOTEL_TO_COLLECTIONS_BUTTON'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeIcon: isAdded,
    icon: _heart.default,
    onClick: handleClick
  }));
};
AddToCollectinButton.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  hotelID: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _react.memo)(AddToCollectinButton);